import { Trait } from "./Trait";

export default Trait;
